import { MultiEntityNostroDetailsComponent } from './../survival-horizon/multi-entity-nostro-details/multi-entity-nostro-details.component';
import { AppConfig } from './../app.config';
import { ForeignOutflowMetric } from './../metrics/foreign-outflow-metric/foreign-outflow-metric';
import {
    ForeignOutflowDetailsComponent
} from './../metrics/foreign-outflow-metric/foreign-outflow-details/foreign-outflow-details.component';
import {
    SuspenseBalanceDetailsComponent
} from './../metrics/suspense-balance-metric/suspense-balance-details/suspense-balance-details.component';
import { Subscription } from 'rxjs';
import { HistoComponent } from './../histo/histo.component';
import { ExplainComponent } from './../explain/explain.component';
import { MenuItem } from 'primeng/api';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DetailPlaceholderComponent } from './detail-placeholder/detail-placeholder.component';
import { DetailDirective } from './detail.directive';
import { DashboardEventService } from '../dashboard/dashboard-event.service';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, ComponentFactoryResolver, Input, Type, ComponentRef } from '@angular/core';
import { IntradayLadderComponent } from '../survival-horizon/intraday-ladder/intraday-ladder.component';
import { UserProfileMultiEntityNostro } from '@liquitics/transaction';
import { FiveDayLadderSelection } from '../survival-horizon/five-day-ladder/five-day-ladder-selection';
import { SuspenseBalanceMetric } from '../metrics/suspense-balance-metric/suspense-balance-metric';

@Component({
    selector: 'app-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.css']
})
export class DetailComponent implements OnInit, AfterViewInit, OnDestroy {
    // @ViewChild(DetailDirective, {static: true}) detailDirective: DetailDirective;
    // items: MenuItem[];
    // activeItem: MenuItem;

    // explainComponent: ExplainComponent;
    // interval: any;

    // componentReferences: Map<string, ComponentRef<any>> = new Map<string, ComponentRef<any>>();

    @ViewChild(ExplainComponent, { static: true }) explainComponent: ExplainComponent;
    @ViewChild(HistoComponent, { static: true }) histoComponent: HistoComponent;
    @ViewChild(ForeignOutflowDetailsComponent, { static: false }) foreignOutflowDetailsComponent: ForeignOutflowDetailsComponent;
    @ViewChild(SuspenseBalanceDetailsComponent, { static: true }) suspenseBalanceDetailsComponent: SuspenseBalanceDetailsComponent;
    @ViewChild(MultiEntityNostroDetailsComponent, { static: true }) multiEntityNostroDetailsComponent: MultiEntityNostroDetailsComponent;
    // @ViewChild(IntradayLadderComponent, {static: true}) intradayLadderComponent: IntradayLadderComponent;

    selectedTabIndex = -1;

    subscription: Subscription;

    constructor(private _componentFactoryResolver: ComponentFactoryResolver,
        private dashboardEventService: DashboardEventService,
        private appConfig: AppConfig) { }


    ngOnInit() {
        // this.items = [
        //     {
        //         label: 'Explain', icon: 'fa-sort-amount-asc', command: (event) => {
        //             this.onTabChange(event);
        //         }
        //     },
        //     // {
        //     //     label: 'My Trades', icon: 'fa-address-book', command: (event) => {
        //     //         this.onTabChange(event);
        //     //     }
        //     // },
        //     {
        //         label: 'Histo Analysis', icon: 'fa-clock-o', command: (event) => {
        //             this.onTabChange(event);
        //         }
        //     },
        //     // {
        //     //     label: 'Stress', icon: 'fa-heartbeat', command: (event) => {
        //     //         this.onTabChange(event);
        //     //     }
        //     // },
        // ];
        this.subscription = this.dashboardEventService.ladderRowSelectionSubject.subscribe({
            next: selection => {
                this.selectedTabIndex = 0;
            }
        });
        this.subscription.add(this.dashboardEventService.metricSelectionSubject.subscribe({
            next: selection => {
                if (selection.selectionType === 'HISTORY') {
                    this.selectedTabIndex = 1;
                } else if (selection.selectionType === 'FOREIGN_CCY_BREAKDOWN') {
                    this.selectedTabIndex = 3;
                    setTimeout(() => {
                        if (this.foreignOutflowDetailsComponent) {
                            const foMetric = selection.metric as ForeignOutflowMetric;
                            this.foreignOutflowDetailsComponent.showMetric(foMetric);
                        }
                    });
                } else if (selection.selectionType === 'THROUGHPUT') {
                    this.selectedTabIndex = 4;
                } else if (selection.selectionType === 'SUSPENSE_BALANCE') {
                    this.selectedTabIndex = 6;
                }
            }
        }));
        this.subscription.add(this.dashboardEventService.projectionMonitoringDataSelectionSubject.subscribe({
            next: selection => {
                this.selectedTabIndex = 1;
            }
        }));
        this.subscription.add(this.dashboardEventService.alertSelectionSubject.subscribe({
            next: selection => {
                this.selectedTabIndex = 2;
            }
        }));
        this.subscription.add(this.dashboardEventService.fiveDayLadderRowSelectionSubject.subscribe({
            next: selection => {
                this.selectedTabIndex = 5;
                setTimeout(() => {
                    if (this.multiEntityNostroDetailsComponent) {
                        this.multiEntityNostroDetailsComponent.currency = selection.currency;
                    }
                })
            }
        }));
        // On profile change reset to nothing...ideally we default to that profile default view
        this.subscription.add(this.dashboardEventService.restartSubject.subscribe({
            next: selection => {
                this.selectedTabIndex = -1;
            }
        }));
        // setTimeout(() => {
        //     this.selectedTabIndex = 0;
        // }, 1000);
    }

    // onTabChange(event) {
    //     if (event.item) {
    //         let componentRef = this.componentReferences.get(event.item.label);
    //         if (!componentRef) {
    //             if (event.item.label === 'Explain') {
    //                 componentRef = this.createComponentRef(ExplainComponent);
    //                 this.explainComponent = componentRef.instance;
    //             } else if (event.item.label === 'Histo Analysis') {
    //                 componentRef = this.createComponentRef(HistoComponent);
    //             }
    //             if (componentRef) {
    //                 this.componentReferences.set(event.item.label, componentRef);
    //             }
    //         }
    //         const viewContainerRef = this.detailDirective.viewContainerRef;
    //         viewContainerRef.detach();
    //         if (componentRef) {
    //             viewContainerRef.insert(componentRef.hostView);
    //         }
    //         this.activeItem = event.item;
    //     }
    // }

    ngAfterViewInit() {


    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    tabSelectChange(event: MatTabChangeEvent) {

    }


    // createComponentRef(componentType: Type<any>): ComponentRef<any> {
    //     const componentFactory = this._componentFactoryResolver.resolveComponentFactory(componentType);
    //     const viewContainerRef = this.detailDirective.viewContainerRef;
    //     viewContainerRef.detach();
    //     const componentRef = viewContainerRef.createComponent(componentFactory);
    //     return componentRef;
    // }
}
